
import { mapGetters,mapActions } from 'vuex'
export default {
 props: {
    question: {
      default: '',
      type: String,
    },
    active: {
      default: '',
      type: String,
    },
    answer: {
      default: '',
      type: String,
    },
 },
 data() {
    return {
      // isActive: this.active !== ''
    }
  },
  computed: {
    ...mapGetters({
      activeFaq : 'pages/getActiveFaq',
    }),
  },
  mounted(){
    if(this.active !== ''){
      this.updateFaq(this.$props.question)
    }
  },
  methods: {
    ...mapActions({
      updateActiveFaq: 'pages/updateActiveFaq',
    }),
    updateFaq(faq){
      this.updateActiveFaq(faq)
      
      // Track via GTM
      this.$gtm.push({
        event: 'faq_click',
        question: faq,
      });

      // Track via rudderstack
      // this.$rs.track("FAQ Click", {
      //   question: faq,
      // }, {
      //   integrations: {
      //     "Klaviyo": false,
      //   },
      // })
    }
  }
}
